export default __webpack_public_path__ + "154cdccdd913f43a8ff8dde7f30bd640.png";